const currentEnv = process.env.REACT_APP_ENV;

export const COOKIE_KEYS = {
    DEALER_LOGIN: 'dealer_logged_in',
    ACCESS_TOKEN: 'access_token',
    CALLBACK_REQUESTES: 'callback_requested',
};

export const googleMapKey = () => {
    const urls = {
        LOCAL: 'AIzaSyAn-3g-gdE93Ag-rpuxIrlFWIMB-kQFabc',
        QA: 'AIzaSyAn-3g-gdE93Ag-rpuxIrlFWIMB-kQFabc',
        STAGING: 'AIzaSyAn-3g-gdE93Ag-rpuxIrlFWIMB-kQFabc',
        PRODUCTION: 'AIzaSyB7mW0X-s_lfDjkDRqc9EJLXW_PY_IJDl4'
    };
    return urls[currentEnv];
};
export const COUNTRY_CODE = {
    INDIA: 'IN',
    UAE: 'AE'
};

export const CURRENCY = {
    IN: '₹',
    AE: 'AED',
    AU: '$'
};

export const DEALER_STATUS = {
    ENLISTED: 'ENLISTED',
    ONBOARDED: 'ONBOARDED',
    BANNED: 'BANNED',
};

export const APP_KEYS = {
    ENTER: 'Enter',
    SEARCH: 'SEARCH',
    NON_SEARCH: 'NON_SEARCH'
};

export const PAGE_SIZE = 10;

export const NUMBER = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
    TEN: 10,
    THIRTEEN: 13,
    SIXTY: 60,
    HUNDRED: 100,
    TWO_HUNDRED: 200,
    TWO_HUNDRED_AND_SEVENTY: 270,
    FIVE_HUNDRED: 500,
    THOUSAND: 1000,
    TWO_THOUSAND: 2000,
    FIVE_THOUSAND: 5000,
    TEN_THOUSAND: 10000,
    FIFTEEN_THOUSAND: 15000,
    SIXTY_THOUSAND: 60000
};

export const TOAST_OPTIONS = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARN: 'warning',
    INFO: 'info'
};

export const INSPECTION_REPORT_TYPE = {
    TEXT: 'text',
    IMAGE: 'image',
    VIDEO: 'VIDEO',
};

export const resetReducerKeys = {
    RESET_TOAST: 'RESET_TOAST',
    RESET_USER: 'RESET_USER',
    RESET_AUCTIONS: 'RESET_AUCTIONS',
    RESET_SEARCH: 'RESET_SEARCH',
    RESET_AUCTION_DETAILS: 'RESET_AUCTION_DETAILS',
    RESET_ORDERS: 'RESET_ORDERS',
    RESET_NOTIFICATIONS: 'RESET_NOTIFICATIONS',
    RESET_WATCH_LIST: 'RESET_WATCH_LIST',
};

export const SEARCH_TYPES = {
    RECENT_SEARCH: 'Recent search',
    SUGGESTED_SEARCH: 'Suggested search'
};
export const AUTH_PRODUCT_TYPE = 'dealer-app-me';
export const AUTH_PRODUCT_TYPE_ME = 'DEALER';

export const COUNTRY_CODES = [
    { code: '+971', initial: 'AE', label: 'United Arab Emirates' },
    { code: '+966', initial: 'KSA', label: 'Kingdom of Saudi Arabia' },
    { code: '+973', initial: 'BH', label: 'Kingdom of Bahrain' },
    { code: '+968', initial: 'OM', label: 'Sultanate of Oman' },
    { code: '+974', initial: 'QA', label: 'Qatar' },
    { code: '+965', initial: 'KW', label: 'State of Kuwait' }
];

export const DEFAULT_COUNTRY_CODE = '+971';

export const HELPLINE_NUMBER = '8001110900';

export const MOBILE_DEVICE_TYPE = {
    ANDROID: 'Android',
    IOS: 'iOS'
};

export const DEALER_STATUS_LABEL = {
    ENLISTED: 'Enlisted',
    ONBOARDED: 'On-Boarded',
    BANNED: 'Banned',
    ADDITIONAL_DETAILS_ADDED: 'Additional Details Added'
};

export const T_AND_C_VERSION = 0.1;

export const AUCTION_TYPE = {
    LIVE: 'LIVE',
    OCB: 'OCB',
    PAI: 'PAI',
    UPCOMING: 'UPCOMING'
};

export const EXPLORE_TABS = [
    { label: 'Live', value: AUCTION_TYPE.LIVE, color: 'active' },
    { label: 'OCB', value: AUCTION_TYPE.OCB, color: 'secondary' },
    { label: 'Upcoming', value: AUCTION_TYPE.UPCOMING, color: 'card-background' }
];

export const WEB_VIEW_EVENTS = {
    DEALER_DATA: 'DEALER_DATA',
    CALL: 'CALL',
    AUTH_TOKEN: 'AUTH_TOKEN',
    LOGOUT: 'LOGOUT'
};

export const REACT_APP_GTM_ID = 'GTM-KJG2Q97';
export const PAINT_IMAGE_LABEL = 'Car Condition Summary';

export const COLOR_TO_HEX_MAPPING = {
    'RED': '#DD2F2F',
};

export const SECTION_KEYS = [ 'MY_WINS', 'MY_DEALS', 'MY_CARS' ];

export const INFO_POP_UP_TEXT = {
    [SECTION_KEYS[0]]: 'Cars you have won in auction.',
    [SECTION_KEYS[1]]: 'Cars processed for transfer to you.',
    [SECTION_KEYS[2]]: 'Cars successfully transferred to you.'
};

export const INFO_POP_UP_DETAILS = {
    [SECTION_KEYS[0]]: [
        {
            heading: 'What comes in MY WINS?',
            points: ['The cars that you have won in auctions.']
        },
        {
            heading: 'What is the expiry of winning bid?',
            points: ['Your winning bid will expire in 48 hrs if the deal is not accepted by the seller.']
        },
    ],
    [SECTION_KEYS[1]]: [
        {
            heading: 'What comes in MY DEALS?',
            points: ['The cars for which your offer has been accepted by the seller and transfer is under process.']
        },
        {
            heading: 'What is the expiry of a deal?',
            points: [
                'If the car is not under loan and it is not transferred to you within 48 hrs, the deal will expire.',
                'If the car is under loan and it is not transferred to you within 20 days, the deal will expire.'
            ]
        },
    ],
    [SECTION_KEYS[2]]: [
        {
            heading: 'What comes in MY CARS?',
            points: ['The cars which are successfully transferred to you.']
        },
    ]
};

export const APP_STORE_LINK=`https://apps.apple.com/ae/app/cars24-uae-partners/id1658294526`;
export const PLAY_STORE_LINK=`https://play.google.com/store/apps/details?id=com.cars24.aedealerapp&hl=en_IN`;